/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 0 = FiftyFifty
 * 1 = ThirtySixty
 * 2 = SixtyThirty
 * 3 = ThirtyThirtyThirty
 */
export enum RowLayouts {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
